import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import isElectron from 'is-electron';
import classNames from 'classnames';
import 'app/lib/confetti';

import './finish.less';

class Finish extends Component {
  static propTypes = {
    pageStrings: PropTypes.shape({
      'onboarding-finish-setup-complete': PropTypes.string.isRequired,
      'onboarding-finish-link-message': PropTypes.string.isRequired,
      'onboarding-finish-closing-message': PropTypes.string.isRequired,
    }).isRequired,
    finalHost: PropTypes.string.isRequired,
    isOrangeMode: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    window.makeConfetti();
  }

  handleClick = () => {
    const { finalHost } = this.props;
    if (isElectron()) {
      window.open(finalHost, '_blank');
      window.close();
    }
  }

  render() {
    const { finalHost, isOrangeMode, pageStrings } = this.props;
    return (
      <div className='Finish contentPage'>
        <h1>Connect Your Glowforge to Wi-Fi</h1>
        <Helmet title='Glowforge Setup' />
        <p className='title'>{pageStrings['onboarding-finish-setup-complete']}</p>
        <a
          href={finalHost}
          onClick={this.handleClick}
          className={classNames('btn', 'clearLink', {
            orange: isOrangeMode,
          })}>
          {pageStrings['onboarding-finish-link-message']}
        </a>
        {isElectron() && (
          <p className='closing-message'>
            {pageStrings['onboarding-finish-closing-message']}
          </p>
        )}
        <canvas id='confetti' />
      </div>
    );
  }
}

export default Finish;



// WEBPACK FOOTER //
// ./app/components/setup/finish.jsx